import { createApp } from 'vue';
import Cr2ToJpgConverter from '../Components/Cr2ToJpgConverter.vue';

const root = document.getElementById('cr2-to-jpg-converter');
if (root) {
  createApp(Cr2ToJpgConverter).mount('#cr2-to-jpg-converter');
}
